module.exports = __webpack_public_path__ + "img/pic_hushoushuang1.abf91fe4.png";